import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Add as AddIcon } from '@mui/icons-material';
import { Button, CircularProgress, Typography } from '@mui/material';
import { SimpleDialog } from 'src/components/modal/simpleDialog';
import { getFileExtension, lang } from 'src/utils';

import { useResourceSelectorSidebarHeader } from './ResourceSelectorSidebarHeader.hook';
import { ResourceSelectorSidebarHeaderProps } from './ResourceSelectorSidebarHeader.interface';
import {
  ResourceSelectorSidebarHeaderButton,
  ResourceSelectorSidebarHeaderContainer,
  StyledText,
  StyledUploadBox,
  UploadInProgress,
} from './ResourceSelectorSidebarHeader.styled';

export const ResourceSelectorSidebarHeader = (
  props: ResourceSelectorSidebarHeaderProps,
) => {
  const {
    uploadNewAsset,
    handleFileInput,
    handleDrop,
    handleDragOver,
    handleDragLeave,
    isDragging,
    overWriteAssetModal,
    handleOverrideAsset,
    handleCancelOverride,
  } = useResourceSelectorSidebarHeader({
    onCloseModal: props?.assetUploadModal?.onCloseModal,
    allowedExtensions: props?.allowedExtensions,
    setFieldValue: props.setFieldValue,
    onSelectAsset: props.onSelectAsset,
    validateFile: props.validateFile,
  });
  const fileExtensions = getFileExtension(props.supportedFileType as string);

  return (
    <>
      {props.assetUploadModal && (
        <StyledUploadBox
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          isDragging={isDragging}>
          <div>
            <Typography display="inline">{lang.dragImage} </Typography>
            <StyledText>
              {lang.selectFile}
              <input
                type="file"
                name="img"
                accept={props.supportedFileType}
                hidden
                onChange={handleFileInput}
              />
            </StyledText>
          </div>

          <Typography variant="caption"> {fileExtensions}</Typography>
        </StyledUploadBox>
      )}

      <ResourceSelectorSidebarHeaderContainer direction="row">
        <ResourceSelectorSidebarHeaderButton
          variant="text"
          startIcon={!props.assetUploadModal && <ArrowBackIcon />}
          onClick={props.onBackClick}>
          {props.label}
        </ResourceSelectorSidebarHeaderButton>

        {props.showUploadButton && (
          <Button variant="outlined" component="label" startIcon={<AddIcon />}>
            {lang.upload}
            <input
              type="file"
              name="img"
              accept={props.supportedFileType}
              hidden
              onChange={handleFileInput}
            />
          </Button>
        )}

        {props.rightElement}
      </ResourceSelectorSidebarHeaderContainer>
      <UploadInProgress open={uploadNewAsset.isLoading}>
        <CircularProgress />
      </UploadInProgress>
      <SimpleDialog
        open={overWriteAssetModal.open}
        cancelText={lang.cancel}
        confirmText={lang.confirm}
        title={lang.overWriteAssetModal.overwriteAssetModalConfirmText}
        onClose={handleCancelOverride}
        onClickCancel={handleCancelOverride}
        subTitle={lang.overWriteAssetModal.overWriteAssetModalSubtitle(
          overWriteAssetModal.fileToOverride?.name as string,
        )}
        modalSize="sm"
        onClickConfirm={handleOverrideAsset}
      />
    </>
  );
};
